import { apiRequest } from "../api/apiService";

/* Dashboard overview */
export const getDashboardOverview = (payload = {}) => {
  return apiRequest({
    method: "POST",
    url: "/admin/dashboard/overview",
    data: payload,
  });
};

/* Batch overview */
export const getBatchOverview = (payload = {}) => {
  return apiRequest({
    method: "POST",
    url: "/admin/dashboard/batch",
    data: payload,
  });
};



/* Programs overview */
export const getProgramsOverview = (payload = {}) => {
  return apiRequest({
    method: "POST",
    url: "/admin/dashboard/programs",
    data: payload,
  });
};

/* Finance Dashboard for Admin */
export const getFinanceDashboard = (payload = {}) => {
  return apiRequest({
    method: "POST",
    url: "/dashboard/finance",
    data: payload,
  });
};
